import 'reflect-metadata';
import Vue from 'vue';
//import Hotjar from 'vue-hotjar'
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import VueToastify from 'vue-toastify';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
// Required dependency of bootstrap css/scss files
import 'bootstrap/scss/bootstrap.scss';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { setDefaults } from './environment/Environment';

import { featureFlags } from '@/config/featureFlags';

const STORAGE_KEY = 'featureFlagsOverride';

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
  window.__FEATURE_FLAGS__ = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};

  window.saveFeatureFlags = function () {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(window.__FEATURE_FLAGS__));
  };
}

// función centralizada
window.getFeatureFlag = function (key) {
  if (window.__FEATURE_FLAGS__ && key in window.__FEATURE_FLAGS__) {
    return window.__FEATURE_FLAGS__[key];
  }
  return featureFlags[key];
};

Vue.prototype.$feature = function (key) {
  return window.getFeatureFlag(key);
};

setDefaults();
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap);
Vue.use(VueToastify, {
  position: 'top-right',
  hideProgressbar: true,
  theme: 'light',
  customNotifications: {
    alertType: {
      body: 'alerta1',
      defaultTitle: false,
      url: '',
      duration: 10000,
    },
  },
});
// newrelic
if (process.env.NODE_ENV !== 'development') {
  const script = document.createElement('script');
  script.src = 'newrelic.js';
  document.head.appendChild(script);
  console.log('loaded newrelic');
} else {
  console.log('newrelic inactive');
}

//Documentacion del sidebar menu https://github.com/yaminncco/vue-sidebar-menu/tree/vue2
Vue.use(VueSidebarMenu);
import i18n from './locales';
import * as GmapVue from 'gmap-vue';

Vue.use(GmapVue, {
  load: {
    key: store.getters.apiKey,
    libraries: 'places', // necessary for places input
  },
  installComponents: true,
});

/*const isDevelepment = process.env.NODE_ENV !== "development";
Vue.use(Hotjar, {
  id: '2853194',
  isProduction: isDevelepment,
});*/

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.prototype.$http = axios;
Vue.prototype.axios = axios;

Vue.component('multiselect', Multiselect);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
export const eventBus_routeDetailModal_routeDetailMap = new Vue();
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
